import { apiClient } from "./client";

export const CANONICAL_FIELDS = [
  "",
  "customer_id_or_name",
  "first_name",
  "last_name",
  "mobile",
  "email",
  "address",
  "transaction_date",
  "product_name",
  "quantity",
  "amount",
];

export const PIPELINE_STAGES = [
  "parsing",
  "mapping",
  "cleansing",
  "loading",
  "scoring",
  "recommendations",
  "done",
];

export async function listOrganizations() {
  const { data } = await apiClient.get("/orgs");
  return data || [];
}

export async function createOrganization(payload) {
  const { data } = await apiClient.post("/orgs", payload);
  return data;
}

export async function deleteOrganization(orgId, { hardDelete = false } = {}) {
  const { data } = await apiClient.delete(`/orgs/${orgId}`, {
    params: hardDelete ? { hard_delete: true } : undefined,
  });
  return data;
}

export async function updateOrganizationReportContact(orgId, payload) {
  const { data } = await apiClient.patch(`/orgs/${orgId}/report-contact`, payload);
  return data;
}

export async function uploadDataset({ orgId, file }) {
  const formData = new FormData();
  formData.append("org_id", orgId);
  formData.append("file", file);
  const { data } = await apiClient.post("/upload", formData);
  return data;
}

export async function getJobStatus(jobId) {
  const { data } = await apiClient.get(`/jobs/${jobId}/status`);
  return data;
}

export async function getJobMapping(jobId) {
  const { data } = await apiClient.get(`/jobs/${jobId}/mapping`);
  return data;
}

export async function confirmJobMapping(jobId, mappings) {
  const { data } = await apiClient.post(`/jobs/${jobId}/confirm-mapping`, {
    mappings,
  });
  return data;
}

export async function getJobResults(jobId) {
  const { data } = await apiClient.get(`/jobs/${jobId}/results`);
  return data;
}

export async function getJobRecommendations(jobId) {
  const { data } = await apiClient.get(`/jobs/${jobId}/recommendations`);
  return data;
}

export async function probeAiMapping() {
  const { data } = await apiClient.get("/debug/ai-probe");
  return data;
}

export function getJobExportUrl(jobId) {
  const baseUrl = (apiClient.defaults.baseURL || "").replace(/\/$/, "");
  return `${baseUrl}/jobs/${jobId}/export`;
}
